import React, { Component } from 'react';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION } from '../../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../../utils/route-auth';

import { useTable, useRowSelect, usePagination, useSortBy } from 'react-table';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
// import Select from '../../../components/FormElements/Select'
import Select from "react-select";
import "../unmapped.scss"
import ToastModal from "../../../../components/ToastModal";


import { options, optionsHistory, formFields } from './constant';

import {
    getUnmappedCampaignListAction,
    getCountUnMappedCampaignAction,
    getCampaignCustomAction,
    postUnmappedCampaignListAction
} from '../../../../actions';
import { log } from 'async';
import { isTenantAgency } from '../../../../selectors';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Tabs = asyncRoute(()=> import('../../../../components/Tabs'));

class index extends Component {
    constructor(props) {
        super(props);
        this.changePage = this.changePage.bind(this);
        this.state = {
            advertiserListData: [],
            optionsList: options,
            confirmationOpen: false,
            confirmationInfo: '',
            submited: false,
            form: {},
            touched: {},
            errors: {},
            getunmappedList: [],
            filterUnmappedCamp: [],
            filteredData: [],
            selectedData: [],
            selectedDspData:[],
            unmppedList: [],
            resetFilter: [],
            visiblePages: this.getVisiblePages(null, props.pages),
            activePage: 1,
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            confirmationMsg: "",
            method: "",
            currentPageSize:25,
            platformsFilterData:[]
        };
    }


    async componentDidMount() {
        // console.log(this.props.tenantId);
        let istenantAgency = isTenantAgency(this.props.tenantId);
        // console.log("isTenantAgency",istenantAgency)
        this.setState({ istenantAgency: istenantAgency });
      }

    // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
    async componentWillMount() {
       
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));

        const { history } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }
       
        // await this.getUnmappedCampaignCount();
        // await this.listadvFilter();
        await this.unMappCampaignListData();
        await this.listCampaignFilter();


    }

    getUnmappedCampaignCount = async () => {
        const { getCountUnMappedCampaignAction, tenantId, authToken, userId } =
          this.props;
        await getCountUnMappedCampaignAction({
          tenantId,
          authToken,
          userId,
        });
      };

    unMappCampaignListData = async () =>{
        const { tenantId, userId, authToken, getUnmappedCampaignListAction,postUnmappedCampaignListAction } = this.props;
        const {selectedData,selectedDspData,selectedAdvertiser} = this.state;

        let advertiserFil = [];
    
        if(selectedAdvertiser && selectedAdvertiser.value != -1){
          advertiserFil.push(selectedAdvertiser.value)
        }
        
        const payload = {
            advId:advertiserFil,
            campaigns:selectedData.map((camp)=>({id:camp.value,value:camp.label})),
            platforms:selectedDspData.map((dspData)=>({id:dspData.value,value:dspData.label}))}
        const {
            responseCode: { status = "" },
            responseList,
        } = await postUnmappedCampaignListAction({ tenantId, authToken, userId,payload });
        if (status == "Success") {
            let unmppedCamp = [];
            let data = []
            let sno = 1;
            responseList.forEach(unmapCamp => {
                let obj = {
                    label: unmapCamp.name,
                    value: unmapCamp.campaignId
                }

                let snoObj = {
                    sno: sno,
                    campaignId: unmapCamp.campaignId,
                    name: unmapCamp.name,
                    platform: unmapCamp.platform
                }

                unmppedCamp.push(obj);
                data.push(snoObj);
                sno++;
            })

            let pageTotal = Math.ceil(responseList.length/25)

            // console.log(data);

            this.setState({ filterUnmappedCamp: unmppedCamp,visiblePages:this.getVisiblePages(1,pageTotal) })

            // if(unmppedCamp.length == 1 )
            // {
            //     this.setState({selectedData : [unmppedCamp[0]] })
            // }


            this.setState({ getunmappedList: data, resetFilter: data, filteredData:data });
            this.setState({ unmppedList: data })

            // console.log(this.props.tenantId);
            // let istenantAgency = isTenantAgency(this.props.tenantId);
            // console.log("isTenantAgency",istenantAgency)
            // this.setState({ istenantAgency: istenantAgency });
        }
    }


    listCampaignFilter = async () => {
        const { tenantId, authToken, userId, getCampaignCustomAction, configurationList } = this.props;
        const { istenantAgency } = this.state;
        const {
          responseCode: { status = "" },
          response,
        } = await getCampaignCustomAction({ tenantId, authToken, userId });
        if (status === "Success") {
          const platformListData = response.platforms.map((item, index) => {
            return { label: item.value, value: item.id };
          });

          const advsData = response.advertisers.map((item, index) => {
            return { label: item.value, value: item.id };
          });
    
          let filteredSelectedAdvertiser = {};
    
          if (advsData && advsData.length == 1 && istenantAgency) {
            filteredSelectedAdvertiser = advsData[0];
          }
          else {
            let objForAll = { label: 'All', value: -1 };
            advsData.unshift(cloneDeep(objForAll))
            filteredSelectedAdvertiser = cloneDeep(objForAll)
          }
        
          this.setState({ advertiserOptionsData:advsData,selectedAdvertiser:filteredSelectedAdvertiser,platformsFilterData: platformListData });
             
        }
      }

    handleAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'existing RO') {
            this.handleExistingRO(row, match, history);
        } else if (action.type === 'new ro') {
            this.hanleNewRO(row, match, history);
        }
    };

    handleExistingRO = async (campaignId) => {
        const { history, match } = this.props;
        localStorage.setItem("unmappedIdArr", JSON.stringify(campaignId));
        history.push(`${match.path}/${routes.unmappedCampaign.mapRO}`)
    }

    hanleNewRO = async (campaignId) => {
        const { history, match } = this.props;
        localStorage.setItem("unmappedIdArr", JSON.stringify(campaignId));
        history.push(`${match.path}/${routes.unmappedCampaign.crateRO}`)
    }

    handleMultipleExistingRo = (selectedFlatRows) => {
        const { history, match } = this.props;
        var newArr = [];
        var idArr = [];
        selectedFlatRows.forEach(element => {
            newArr.push(element.original);
        });

        if (newArr.length > 0) {
            newArr.forEach(item => {
                idArr.push(item.campaignId);
            })
        }

        if (idArr.length > 0) {
            localStorage.setItem("unmappedIdArr", JSON.stringify(idArr));
            history.push(`${match.path}/${routes.unmappedCampaign.mapRO}`)
        } else {
            // alert("Campaign Not Selected");
            this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Campaign Not Selected" });

        }
    }

    handleMultipleNewRo = (selectedFlatRows) => {
        const { history, match } = this.props;
        var newArr = [];
        var idArr = [];
        selectedFlatRows.forEach(element => {
            newArr.push(element.original);
        });

        if (newArr.length > 0) {
            newArr.forEach(item => {
                idArr.push(item.campaignId);
            })
        }

        if (idArr.length > 0) {
            localStorage.setItem("unmappedIdArr", JSON.stringify(idArr));
            history.push(`${match.path}/${routes.unmappedCampaign.crateRO}`)
        } else {
            // alert("Campaign Not Selected");\
            this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Campaign Not Selected" });

        }
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };

    filterPages = (visiblePages, totalPages) => {
        return visiblePages.filter((page) => page <= totalPages);
    };

    getVisiblePages = (page, total) => {
        // console.log(total,page,total ? total: 0);
        if (total < 7) {
            return this.filterPages([1, 2, 3, 4, 5, 6], total);
        } else {
            if (page % 5 >= 0 && page > 4 && page + 2 < total) {
                return [1, page - 1, page, page + 1, total];
            } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
                return [1, total - 3, total - 2, total - 1, total];
            } else {
                return [1, 2, 3, 4, 5, total ? total : ''];
            }
        }
    };

    changePage(page, pageOptions, gotoPage) {
        const activePage = page + 1;
        this.setState({ activePage: page })
        if (page === activePage) {
            return;
        }

        const visiblePages = this.getVisiblePages(page, pageOptions.length);

        this.setState({
            visiblePages: this.filterPages(visiblePages, pageOptions.length)
        });

        gotoPage(page - 1);

        // this.props.onPageChange(page - 1);
    }


    // table data
    Table = ({ columns, data, fetchData, loading, pageCount: controlledPageCount }) => {
        const { visiblePages, activePage,istenantAgency } = this.state;
        const IndeterminateCheckbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
            const defaultRef = React.useRef();
            const resolvedRef = ref || defaultRef;


            // React.useEffect(() => {
            //     resolvedRef.current.indeterminate = indeterminate
            // }, [resolvedRef, indeterminate])

        
            // Conditionally set the indeterminate property only when the checkbox is rendered
            if (resolvedRef.current) {
              resolvedRef.current.indeterminate = indeterminate;
            }
        
            // Conditionally render the checkbox based on istenantAgency
            if (istenantAgency) {
              return <></>; // Return an empty fragment if istenantAgency is true (no checkbox)
            }

                return (
                    <>
                        <input type="checkbox" ref={resolvedRef} {...rest} />
                    </>
                )
            }
        )

        const initialState = {
            pageSize: 25,
            pageIndex: 0,
            hiddenColumns: ['campaignId']
        };

        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            prepareRow,
            page,
            canPreviousPage,
            canNextPage,
            pageOptions,
            pageCount,
            gotoPage,
            nextPage,
            previousPage,
            setPageSize,
            selectedFlatRows,
            state: { pageIndex, pageSize }
        } = useTable(
            {
                columns,
                data,
                initialState,
                // getRowId: (row, index) => {
                //     return row.id;
                // },
                autoResetPage: true,
                autoResetSelectedRows: false,
                autoResetRowState: false,
            },
            useSortBy,
            usePagination,
            useRowSelect,
            hooks => {
                hooks.visibleColumns.push(columns => [
                    {
                        id: 'selection',
                        Header: ({ getToggleAllRowsSelectedProps }) => (
                            <div>
                                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                            </div>
                        ),
                        Cell: ({ row }) => (
                            <div>
                                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                            </div>
                        ),

                    },
                    ...columns,
                ])
            }
        );

        // console.log(visiblePages,'$$$$$$$$$$$$$$$$$')
        //change
        return (
            <>
                <table {...getTableProps()} className="unmappedCampTable">
                    <thead>
                        {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                {column.render("Header")}{" "}
                                <span>
                                {column.isSorted ? (column.isSortedDesc ? "" : "") : ""}
                                </span>
                            </th>
                            ))}
                        </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {data.length === 0 ? (
                       <tr>
                       <td colSpan={istenantAgency ? 4 : 5} style={{ textAlign: "center" }}>
                         No results found.
                       </td>
                     </tr>
                        ) : (
                        page.map((row, i) => {
                            prepareRow(row);
                            return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                })}
                            </tr>
                            );
                        })
                        )}
                    </tbody>
                </table>
                {!istenantAgency && data.length > 0 &&
                <div className='tableButtons mt-3'>
                    <button onClick={() => this.handleMultipleExistingRo(selectedFlatRows)}>Map With Existing Goal</button>
                    <button onClick={() => this.handleMultipleNewRo(selectedFlatRows)}>Create New Goal</button>
                </div>
                }
                <div className='paginationParentDiv mt-5 mb-5'>
                    <div className='pageRange'>
                        <span style={{ fontSize: '0.8125rem',color:'#5d596c' }}>
                            Rows Per Page:
                        </span>
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                let totalSize = Math.ceil(data.length/Number(e.target.value));
                                // console.log(totalSize)
                                this.setState({activePage:1,visiblePages:this.getVisiblePages(1,totalSize),currentPageSize:Number(e.target.value)},()=>{
                                gotoPage(0)
                                })
                            }}
                            className="ml-4"
                        >
                            {[25, 50, 100].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                </option>
                            ))}
                        </select>
                    </div>
                    {
                        data.length > 0 &&
                    <div className="pagination">
                        <button onClick={() => {
                            if (activePage === 1) return;
                            this.changePage(activePage - 1, pageOptions, gotoPage);
                        }} disabled={activePage === 1}>Previous</button>
                        {visiblePages.map((page, index, array) => {
                            return (
                                <React.Fragment>
                                    { array[index - 1] + 1 < page &&
                                     <button
                                    //  key={page}
                                    //  className={page === activePage ? "paginationActive" : ""}
                                     onClick={this.changePage.bind(null, (index + 1) == array.length ? array[index] - 1 : 1, pageOptions, gotoPage)}
                                 >
                                  ...   
                                 </button>
                                    }
                                <button
                                    key={page}
                                    className={page === activePage ? "paginationActive" : ""}
                                    onClick={this.changePage.bind(null, page, pageOptions, gotoPage)}
                                >
                                    {array[index - 1] + 1 < page ? `${page}` : page}
                                </button>
                                </React.Fragment>
                            );
                        })}
                        <button onClick={() => {
                            this.changePage(activePage + 1, pageOptions, gotoPage);
                        }} disabled={!canNextPage}>
                            Next
                        </button>
                    </div>
                     }
                </div>
            </>
        )
    }

    handleFilterChange = (selected,type="") => {
        const { selectedData } = this.state;
        if(type == 'camp'){
        this.setState({ selectedData: selected })
        }
        else if (type == 'advertiser') {
            this.setState({ selectedAdvertiser: selected })
        }
        else{
            this.setState({selectedDspData:selected})
        }
    }

    applyFilter = (e) => {
        e.preventDefault();
        this.setState({activePage:1})
        this.unMappCampaignListData();
        // const { selectedData, unmppedList,currentPageSize } = this.state;

        // const filteredData = unmppedList.filter(item => item.name === selectedData.value);

        // if (filteredData.length > 0) {
        //     let totalSize = Math.ceil(filteredData.length/currentPageSize);
        //     this.setState({ getunmappedList: filteredData,visiblePages:this.getVisiblePages(1,totalSize),activePage:1  })
        // }
    }

    handleReset = async (e) => {
        e.preventDefault();
        const { resetFilter,currentPageSize } = this.state;

        // console.log(resetFilter);
        let totalSize = Math.ceil(resetFilter.length/currentPageSize);

        this.setState({ selectedData: [], selectedDspData:[],activePage:1 },()=>{
            this.unMappCampaignListData();
        })
        // this.setState({allMarginData: this.state.ListOriginalData});
    }
    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
      }
    
      confirmationCallbackModel = (id) => {
        const { method, tableAction, tableRow } = this.state;
        this.setState({ enableToast: false });
    
      }
    
    
      handleToastStatus = (status) => {    
        this.setState({ enableToast: status });
      }

      handleSearch = (event) => {
        const searchTerm = event.target.value;
        const { getunmappedList,currentPageSize } = this.state;
    
        // Create a clone of getunmappedList
        const clonedData = _.cloneDeep(getunmappedList);
     
        // Modify the cloned array based on the search term
        const filteredData = clonedData.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.platform.some((platformItem) =>
          platformItem.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    
        // Update the state with the new search term and filtered data
        let totalSize = Math.ceil(filteredData.length/currentPageSize);
        this.setState({ searchTerm,filteredData: filteredData,visiblePages:this.getVisiblePages(1,totalSize),activePage:1  })
      };
      



    render() {
        const tableIoData = this.state.advertiserListData;
        const { match, ioListAll, configurationList } = this.props;
        const { istenantAgency,selectedDspData,platformsFilterData,filteredData,searchTerm,confirmationOpen, confirmationInfo, optionsList,selectedData,selectedAdvertiser,advertiserOptionsData, getunmappedList, form, submited, touched, errors, filterUnmappedCamp, enableToast, toastMsg, toastStatus, confirmationMsg, method } = this.state;

        const dataForTable = searchTerm && filteredData.length === 0 ? [] : filteredData.length > 0 ? filteredData : getunmappedList;
        const columns = [
            {
                Header: 'Name',
                columns: [
                    {
                        Header: "S.No",
                        id: "row",
                        maxWidth: 50,
                        filterable: false,
                        Cell: (row) => {
                            return <div>{row.row.index + 1}</div>;
                        }
                    },
                    {
                        Header: 'S.No',
                        accessor: 'campaignId',
                        isVisible: false
                    },
                    {
                        Header: 'Campaign Name',
                        accessor: 'name',
                        Cell:(row) =>{
                            if(row && row.row && row.row.values && row.row.values.name){
                                 return <div title={row.row.values.name}>{row.row.values.name.length > 58 ? `${row.row.values.name.slice(0,58)} ...`: row.row.values.name }</div>;   
                            }
                        }
                    },
                    {
                        Header: 'DSP Platform',
                        accessor: 'platform',
                    },
                    {
                        Header: 'Options',
                        Cell: ({ cell }) => (
                          
                            <>  
                                    <button onClick={() => this.handleExistingRO(cell.row.values.campaignId)}>
                                        <i className='mdi mdi-pencil-box-outline' style={{ color: 'rgb(80,110,228)' }}></i> Map With Existing Goal
                                    </button>
                                    <button onClick={() => this.hanleNewRO(cell.row.values.campaignId)}>
                                        <i className='mdi mdi-pencil-box-outline' style={{ color: 'rgb(80,110,228)' }}></i> Create New Goal
                                    </button>
                            </>

                        )
                    },
                ],
            }
        ];

        const filteredColumns = istenantAgency
        ? columns.map((colGroup) => ({
            ...colGroup,
            columns: colGroup.columns.filter((col) => col.Header !== 'Options'),
          }))
        : columns;

        
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}

                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        // path={routes.containers.mediaPlan}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                        poc={true}
                    />
                }
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3">
                            <Card>
                            <Tabs container="goals" />
                                <div class="accordion mt-4" id="accordionWithIcon">
                                    <div class="accordion-item card">
                                        <h2 class="accordion-header d-flex align-items-center">
                                            <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-2" aria-expanded="true">
                                                <i class="me-2 ti ti-filter ti-xs"></i>
                                                Filter Campaign
                                            </button>
                                        </h2>
                                        <div id="accordionWithIcon-2" class="accordion-collapse collapse show" >
                                            <div class="accordion-body pb-3">
                                                <div className="row">
                                                    {
                                                        istenantAgency &&
                                                        <div className='col-md-4'>
                                                            <label style={{ fontSize: "14px",color:'#5d596c' }}>Advertiser</label>
                                                            <Select
                                                                options={advertiserOptionsData}
                                                                isMulti={false}
                                                                placeholder="All"
                                                                defaultValue={selectedAdvertiser}
                                                                value={selectedAdvertiser}
                                                                onChange={(selected) => this.handleFilterChange(selected, "advertiser")}
                                                                className="campaignFilter"
                                                            />
                                                        </div>
                                                    }
                                                <div className='col-md-4'>
                                                            <label style={{ fontSize: "14px",color:'#5d596c' }}>Campaign Name</label>
                                                            
                                                                <Select
                                                                    options={filterUnmappedCamp}
                                                                    defaultValue={selectedData}
                                                                    value={selectedData}
                                                                    onChange={(selected) => this.handleFilterChange(selected,'camp')}
                                                                    className="unmappedFilter"
                                                                    placeholder="--Select--"
                                                                    isMulti={true}
                                                                />
                                                            </div>
                                                            <div className='col-md-4'>
                                                            <label style={{ fontSize: "14px",color:'#5d596c' }}>DSP Platform</label>
                                                            
                                                                <Select
                                                                    options={platformsFilterData}
                                                                    defaultValue={selectedDspData}
                                                                    value={selectedDspData}
                                                                    onChange={(selected) => this.handleFilterChange(selected,'plat')}
                                                                    className="unmappedFilter"
                                                                    placeholder="--Select--"
                                                                    isMulti={true}
                                                                />
                                                            </div>
                                                    <div className='col-md-12 d-flex justify-content-between justify-content-md-end mt-2'>
                                                                <button onClick={(e) => this.applyFilter(e)} className="btn btn-primary h4 m-0 p-2"><i className='mdi mdi-account-check'></i>Apply</button>
                                                                <button className="btn btn-primary h4 ml-3 m-0 p-2" onClick={(e) => this.handleReset(e)}><i class="mdi mdi-replay"></i>Reset</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="row">
                                    <div className="col-md-12 grid-margin mb-0">
                                        <div className='row align-items-center'>
                                            <div className='col-md-2'>
                                                <p style={{ fontSize: "14px" }}>Campaign Name:</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <Select
                                                    options={filterUnmappedCamp}
                                                    defaultValue={selectedData}
                                                    value={selectedData}
                                                    onChange={(selected) => this.handleFilterChange(selected)}
                                                    className="unmappedFilter"
                                                />
                                            </div>
                                            <div className='col-md-4'>
                                                <button onClick={(e) => this.applyFilter(e)} className="btn btn-primary h4 m-0 p-2"><i className='mdi mdi-account-check'></i>Apply</button>
                                                <button className="btn btn-primary h4 ml-3 m-0 p-2" onClick={(e) => this.handleReset(e)}><i class="mdi mdi-replay"></i>Reset</button>

                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {/* </Card>
                            <Card> */}

                            {/* <div className="search-bar">
                                    <input
                                        type="text"
                                        placeholder="Search by name"
                                        value={searchTerm}
                                        onChange={this.handleSearch}
                                    />
                                    </div> */}

                            <div className='d-flex justify-content-end mt-4'>
                                <div class="search-bar">
                                <span class="search-icon"><i className='ti ti-search'></i></span>
                                <input
                                    type="text"
                                    class="search-input"
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={this.handleSearch}
                                />
                                </div>
                            </div>

                                <div className="table-responsive unmappedCampaign mt-3">
                                    {
                                         <this.Table columns={filteredColumns} data={dataForTable} />
                                    }
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getUnmappedCampaignListAction,
        getCountUnMappedCampaignAction,
        getCampaignCustomAction,
        postUnmappedCampaignListAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    ioListAll: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getIoListAllReportAction: PropTypes.func,
    deleteIoAction: PropTypes.func,
    pages: PropTypes.number,
    page: PropTypes.number,
    // previousText: PropTypes.string,
    // nextText: PropTypes.string
};